/** Display punctuation policy. Original API values stay intact for edits and saves. */
export function siteText<T>(value: T): T {
  if (typeof value !== 'string') return value
  return value.replace(/\s*\u2014\s*/g, ', ').replace(/^,\s*$/, 'Not available') as T
}

/** Speaker credits use a comma between names, including parenthetical credits. */
export function speakerCredit(value: string): string {
  return siteText(value)
    .replace(/\s*\(\s*with\s+([^)]*)\)/gi, ', $1')
    .replace(/\s*,?\s*\bwith\s+/gi, ', ')
    .replace(/(?:,\s*)+/g, ', ')
    .replace(/^,\s*|,\s*$/g, '')
    .trim()
}
